import {Injectable, inject, signal} from '@angular/core';
import {OctopusConnectService, DataEntity} from 'octopus-connect';
import {map, tap} from 'rxjs/operators';
import {IackathonSaveAttributes} from '../models/iackathon-save.attributes';

type RawIackathonSaveAttributes = Omit<IackathonSaveAttributes, 'content'> & { content: string };
export type IackathonSave = { id: string; attributes: IackathonSaveAttributes };

@Injectable({
    providedIn: 'root',
})
export class IackathonSavesService {
    private octopusConnect = inject(OctopusConnectService);

    public readonly cachedSaves = signal<IackathonSave[]>([]);

    public fetchSaves() {
        return this.octopusConnect.loadCollection<RawIackathonSaveAttributes>('iackathon', {
            showLearners: 'true'
        }).pipe(
            map(saveCollection => saveCollection.entities.map(entity =>
                ({
                    id: entity.id.toString(),
                    attributes: {
                        ...entity.attributes,
                        content: JSON.parse(entity.attributes.content)
                    }
                } as IackathonSave))),
            tap(entities => this.cachedSaves.set(entities)),
        );
    }
}
